import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// To use this component, it should be included in the root of an element that
// has a position defined (e.g. position: relative) so that it can fill the
// space using absolute positioning

const ExpandableModalPanel = ({
  children,
  isOpen,
  onOverlayClick = () => {},
}) => (
  <div
    className={classNames(
      'md:hidden bottom-0 flex-col left-0 absolute right-0 top-0 z-[1]',
      {
        hidden: !isOpen,
        flex: isOpen,
      }
    )}
  >
    <div className="bg-white">{children}</div>
    <button
      label="button"
      type="button"
      className="flex-1"
      onClick={onOverlayClick}
    />
  </div>
);

ExpandableModalPanel.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.objectOf(PropTypes.node),
  onOverlayClick: PropTypes.func,
};

export default ExpandableModalPanel;
